module.exports = __webpack_public_path__ + "img/screenrecoder-tips.22d7c910.png";